import _ from 'lodash'
import Vue from 'vue'
import uniqid from 'uniqid'

import store from '@/store'
import pinia from '@/pinia';
import { adminClient as apolloClient } from '@/store/apollo';
import { useAuthStore, useSetupStore } from '@/stores'

import PaginatedItems from '@/components/PaginatedItems'
import PropertyValue from '../Partials/PropertyValue'

export default {
    data() {
        return {
            scope: 'ex',
            key: 'shop_purchase_article',
            disable: {
                showFilters: false,
            },
            showActions: true,
            modalVisibility: false,
            modalLoading: false,
            modalType: 'new', // valid options: 'new' / fresh / 'existing'
            modal: {
                id: undefined,
                name: '',
            },
            pagination: {
                filters: {},
                variables: {
                    paginationSizes: [5, 10, 50],
                },
                pageInfo: {
                    currentPage: 1,
                    lastPage: 1,
                    perPage: 10,
                    total: 0,
                }
            }
        }
    },
    components: {
        PaginatedItems,
        PropertyValue
    },
    watch: {
        items(items) {
            this.pagination.pageInfo.total = items.length
            this.pagination.pageInfo.lastPage = Math.ceil(items.length / this.pagination.pageInfo.perPage)
        }
    },
    computed: {
        hasBulkActions() {
            return false;
        },
        showFilters() {
            return this.hasFilters || _.get(this.articlesPaginated, 'showFilters') || false;
        },
        hasFilters() {
            return !_.isEmpty(this.filters);
        },
        allColumns() {
            let allColumns = this.articlesPaginated.allColumns;
            return allColumns;
        },
        activeColumns() {
            let activeColumns = this.articlesPaginated.activeColumns;
            return activeColumns;
        },
        filters() {
            let filters = _.cloneDeep(this.articlesPaginated.filters);
            delete filters.shop;
            delete filters.product;
            return filters;
        },
        activeShop() {
            return this.activeCms.shop;
        },
        loading() {
            return this.ui.articlesPaginated.loading;
        },
        currency() {
            return _.get(this.form, 'purchaser.customer.customerGroup.currency.iso4217')
                || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency.iso4217')
        },
        modalTitle() {
            let title = this.$t('Add article to cart')
            if (this.modalType === 'existing' && this.modal.name) {
                title = this.modal.name
            }
            return title
        },
        rules() {
            return {}
        },
        user() {
            return useAuthStore().user;
        },
        isSuperUser() {
            return useAuthStore().isSuperUser;
        },
        setupStore() {
            return useSetupStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
    },
    methods: {
        changePaginationSize(itemsPerPage) {
            this.updateLoading(true);
            this.defineItemsPerPage(itemsPerPage);
            this.refetch();
        },
        changeCurrentPage(currentPage) {
            this.updateLoading(true);
            this.defineCurrentPage(currentPage);
            this.refetch();
        },
        changeTableColumns(visibleColumns) {
            this.defineActiveColumns(visibleColumns);
            // apolloClient.cache.reset()
            apolloClient.clearStore();
        },
        changeFilter(key, value, debounce = true) {
            this.defineCurrentPage(1);
            this.defineFilterValue({ key, value });
            if (debounce) this.debouncedRefetch();
            else this.refetch();
        },
        changeSort(key, value, debounce = true) {
            this.defineSort({ key, value });
            if (debounce) this.debouncedRefetch();
            else this.refetch();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters;

            let value = false;
            if (!visible) value = true;

            this.disable.showFilters = true;
            this.defineFilterVisibility(value);
            // this.saveFilterVisibility({ scope: 'cp', key: this.key, value })
            this.saveFilterVisibility({ scope: this.scope, key: this.key, value })
                .finally(() => (this.disable.showFilters = false)
            );
        },
        refetch() {
            // set shop filter
            if (this.activeShop) {
                const key = 'shop';
                const value = {
                    key,
                    match: this.activeShop.id,
                    like: '',
                    from: '',
                    to: '',
                    in: []
                };
                this.defineFilterValue({ key, value });
            }

            this.updateLoading(true);
            return this.fetchArticlesPaginated({
                scope: this.scope,
                type: this.key,
                includeWebShopPurchases: _.get(this, 'includeWebShopPurchases', true),
                includeInternals: _.get(this, 'includeInternals', false),
                includePointOfSalePurchases: _.get(this, 'includePointOfSalePurchases', false)
            })
                .then(() => this.updateLoading(false))
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                    this.updateLoading(false);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Article list could not be fetched.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        debouncedRefetch: _.debounce(function() {
            // function scope is needed here
            this.updateLoading(true);
            this.refetch();
        }, useSetupStore(pinia).debounce || 300),
        openItemModal(item = null) {
            // TODO
            return false

            // this.modalLoading = true
            // this.modalVisibility = true

            // if (item && item instanceof Event === false) {
            //     this.modal = _.cloneDeep(item)
            //     if (item && _.startsWith(item.id, 'new:')) {
            //         this.modalType = 'fresh'
            //     } else {
            //         this.modalType = 'existing'
            //     }
            // } else {
            //     this.modal.id = uniqid('new:')
            //     this.modalType = 'new'
            // }

            // this.modalLoading = false
        },
        closeModal() {
            this.modalVisibility = false
            this.modalLoading = false
        },
        submitModalForm() {
            if (this.modalType === 'new') {
                // add item to cart
                this.$refs.modal.validate(valid => {
                    if (valid) {
                        this.addItem(this.modal)
                        this.closeModal()
                    }
                })
            } else {
                // replace item in cart
                this.updateItem(this.modal)
                this.closeModal()
            }
        },
        closeModal() {
            this.modal.visibility = false;
        },
        resetModal() {
            this.modal = {
                id: undefined,
                name: '',
            }
            this.$refs.modal.resetFields()
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        },
    },
}
